const Applications = {
    1: 'marketplace',
    2: 'picking',
    3: 'wms',
    4: 'eikow',
    5: 'stripe',
    6: 'statistics'
}

const ApplicationsName = {
    1: 'Marketplace',
    2: 'OMS',
    3: 'WMS',
    4: 'Eikow',
    5: 'Stripe',
    6: 'Statistics'
}

export const APPLICATIONS = {
    MARKETPLACE: 1,
    OMS: 2,
    WMS: 3,
    EIKOW: 4,
    STRIPE: 5,
    STATISTICS: 6,
    getName: (application) => ApplicationsName[application],
    getBackendName: (application) => Applications[application]
}

